import { defineMessages } from 'react-intl';
var messages = defineMessages({
  leaveCommentLabel: {
    id: "LessonDetails.leaveCommentLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Leave your comment at "
    }, {
      "type": 1,
      "value": "time"
    }]
  },
  privateLabel: {
    id: "LessonDetails.privateLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Private"
    }]
  },
  savingLabel: {
    id: "LessonDetails.savingLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Saving..."
    }]
  },
  sourcesLabel: {
    id: "LessonDetails.sourcesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Sources"
    }]
  },
  saveLabel: {
    id: "LessonDetails.saveLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Save"
    }]
  },
  backToTitle: {
    id: "LessonDetails.backToTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Back to "
    }, {
      "type": 1,
      "value": "name"
    }]
  },
  upNextText: {
    id: "LessonDetails.upNextText",
    defaultMessage: [{
      "type": 0,
      "value": "Up next:"
    }]
  },
  noteSuccessAddMsg: {
    id: "LessonDetails.noteSuccessAddMsg",
    defaultMessage: [{
      "type": 0,
      "value": "The note has been added to the timeline"
    }]
  },
  browserDoesntSupportAudioMsg: {
    id: "LessonDetails.browserDoesntSupportAudioMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Your browser does not support the audio element."
    }]
  },
  addNoteLabel: {
    id: "LessonDetails.addNoteLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Add note"
    }]
  },
  hideNotesTitle: {
    id: "LessonDetails.hideNotesTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Hide notes"
    }]
  },
  showNotesTitle: {
    id: "LessonDetails.showNotesTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Show notes"
    }]
  },
  notesBtnTitle: {
    id: "LessonDetails.notesBtnTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Notes"
    }]
  },
  completingBtnMsg: {
    id: "LessonDetails.completingBtnMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Completing lesson..."
    }]
  },
  completedBtnMsg: {
    id: "LessonDetails.completedBtnMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Completed! Rate content"
    }]
  },
  completedOfflineBtnMsg: {
    id: "LessonDetails.completedOfflineBtnMsg",
    defaultMessage: [{
      "type": 0,
      "value": "Completed"
    }]
  },
  completeBtnmsg: {
    id: "LessonDetails.completeBtnmsg",
    defaultMessage: [{
      "type": 0,
      "value": "Complete"
    }]
  },
  nextBtnTooltip: {
    id: "LessonDetails.nextBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Next: "
    }, {
      "type": 1,
      "value": "name"
    }]
  },
  nextBtnLabel: {
    id: "LessonDetails.nextBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Next"
    }]
  },
  showCertificateBtnLabel: {
    id: "LessonDetails.showCertificateBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show course certificate"
    }]
  },
  completedLessonsInSection: {
    id: "LessonDetails.completedLessonsInSection",
    defaultMessage: [{
      "type": 1,
      "value": "completedLessons"
    }, {
      "type": 0,
      "value": " completed lesson(s) of "
    }, {
      "type": 1,
      "value": "totalLessons"
    }, {
      "type": 0,
      "value": " total lesson(s) in the section"
    }]
  },
  thereIsNoNotesYet: {
    id: "LessonDetails.thereIsNoNotesYet",
    defaultMessage: [{
      "type": 0,
      "value": "No notes to show yet"
    }]
  },
  highlightLabel: {
    id: "LessonDetails.highlightLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Highlight"
    }]
  },
  privateCheckboxHint: {
    id: "LessonDetails.privateCheckboxHint",
    defaultMessage: [{
      "type": 0,
      "value": "(Don’t show in course discussion)"
    }]
  },
  cancel: {
    id: "LessonDetails.cancel",
    defaultMessage: [{
      "type": 0,
      "value": "Cancel"
    }]
  },
  isTranscoding: {
    id: "LessonDetails.isTranscoding",
    defaultMessage: [{
      "type": 0,
      "value": "Video is still being transcoded, try again soon"
    }]
  },
  close: {
    id: "General.closeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "close"
    }]
  },
  clickOnVideoToExitFullScreen: {
    id: "LessonDetails.clickOnVideoToExitFullScreen",
    defaultMessage: [{
      "type": 0,
      "value": "Click on video to exit fullscreen"
    }]
  },
  optionIsNotAvailableForTrial: {
    id: "LessonDetails.optionIsNotAvailableForTrial",
    defaultMessage: [{
      "type": 0,
      "value": "Changing this option is not available for Trial users"
    }]
  },
  notAvailableInOfflineMode: {
    id: "LessonDetails.notAvailableInOfflineMode",
    defaultMessage: [{
      "type": 0,
      "value": "Not available in offline mode"
    }]
  },
  notAvailableOffline: {
    id: "LessonDetails.notAvailableOffline",
    defaultMessage: [{
      "type": 0,
      "value": "(not available offline)"
    }]
  },
  switchToVideoView: {
    id: "LessonDetails.switchToVideoView",
    defaultMessage: [{
      "type": 0,
      "value": "Switch to Video view"
    }]
  },
  switchToAudioView: {
    id: "LessonDetails.switchToAudioView",
    defaultMessage: [{
      "type": 0,
      "value": "Switch to Audio view"
    }]
  },
  switchToTextView: {
    id: "LessonDetails.switchToTextView",
    defaultMessage: [{
      "type": 0,
      "value": "Switch to Text view"
    }]
  },
  course: {
    id: "LessonDetails.course",
    defaultMessage: [{
      "type": 0,
      "value": "Course"
    }]
  },
  changeLogMenuItem: {
    id: "LessonDetails.changeLogMenuItem",
    defaultMessage: [{
      "type": 0,
      "value": "Current lesson changelog"
    }]
  },
  changelog: {
    id: "LessonDetails.changelog",
    defaultMessage: [{
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " - Changelog"
    }]
  },
  serviceNamePossessive: {
    id: "LessonDetails.defaultServiceNamePossessive",
    defaultMessage: [{
      "type": 0,
      "value": "Skhole"
    }]
  },
  leaveCourseRating: {
    id: "LessonDetails.leaveCourseRating",
    defaultMessage: [{
      "type": 0,
      "value": "Leave course rating"
    }]
  },
  editCourseRating: {
    id: "LessonDetails.editCourseRating",
    defaultMessage: [{
      "type": 0,
      "value": "Edit course rating"
    }]
  },
  videoCommentAriaLabel: {
    id: "LessonDetails.videoCommentAriaLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Video comment"
    }]
  },
  emptyContentMessage: {
    id: "LessonDetails.emptyContentMessage",
    defaultMessage: [{
      "type": 0,
      "value": "This lesson has no text format available. However, you can listen to it as audio track instead"
    }]
  },
  attachedCoursesByUsersBtn: {
    id: "LessonDetails.attachedCoursesByUsersBtn",
    defaultMessage: [{
      "type": 0,
      "value": "See courses on this topic"
    }]
  },
  attachedCoursesByUsersBtnTooltip: {
    id: "LessonDetails.attachedCoursesByUsersBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Show courses that include this lesson"
    }]
  },
  enSubtitlesLabel: {
    id: "LessonDetails.enSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "English"
    }]
  },
  fiSubtitlesLabel: {
    id: "LessonDetails.fiSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Suomi"
    }]
  },
  ruSubtitlesLabel: {
    id: "LessonDetails.ruSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Русский"
    }]
  },
  arSubtitlesLabel: {
    id: "LessonDetails.arSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "العربية"
    }]
  },
  soSubtitlesLabel: {
    id: "LessonDetails.soSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Soomaali"
    }]
  },
  etSubtitlesLabel: {
    id: "LessonDetails.etSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Eesti"
    }]
  },
  ukSubtitlesLabel: {
    id: "LessonDetails.ukSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Українська"
    }]
  },
  faSubtitlesLabel: {
    id: "LessonDetails.faSubtitlesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "فارسی"
    }]
  }
});
export default messages;